import { MdCreditCard, MdPersonAdd, MdAssignment } from "react-icons/md";

export const dashboardConstants = {
  GET_CARDPROGRAM_COUNT_REQUEST: "GET_CARDPROGRAM_COUNT_REQUEST",
  GET_CARDPROGRAM_COUNT_SUCCESS: "GET_CARDPROGRAM_COUNT_SUCCESS",
  GET_CARDPROGRAM_COUNT_FAILURE: "GET_CARDPROGRAM_COUNT_FAILURE",
  GET_CARDPROGRAM_COUNT_RESET: "GET_CARDPROGRAM_COUNT_RESET"
};

export const quicklinks = [
  {
    path: "/card-requests/create",
    title: "Create card",
    icon: MdCreditCard
  },
  {
    path: "/users/add",
    title: "Create User",
    icon: MdPersonAdd
  },
  {
    path: "/card-statement",
    title: "Card Statement",
    icon: MdAssignment
  }
];
